import { render, staticRenderFns } from "./RepresentativeOrganization.vue?vue&type=template&id=f7621410&scoped=true"
import script from "./RepresentativeOrganization.vue?vue&type=script&lang=ts"
export * from "./RepresentativeOrganization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7621410",
  null
  
)

export default component.exports